import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ReportTypeTable = () => {
  const reportTypeData = [
    {
      id: 1,
      report_type: 'MRI',
      asset_id_field: 'asset_id_1',
      custom_id_field: 'custom_id',
      asset_title_field: 'asset_title',
      asset_label_field: 'asset_labels',
      earnings_field: 'Not Assigned',
      platform: 'None',
      alias: 'No Aliases',
      report_fields: ['service_name',],
    },
    {
      id: 2,
      report_type: 'HFA',
      asset_id_field: 'asset_id_2',
      custom_id_field: 'custom_id',
      asset_title_field: 'asset_title',
      asset_label_field: 'asset_labels',
      earnings_field: 'Not Assigned',
      platform: 'None',
      alias: 'No Aliases',
      report_fields: ['Transaction Description',],
    },
    {
      id: 3,
      report_type: 'Adjusted Label Sound Recording',
      asset_id_field: 'asset_id_3',
      custom_id_field: 'custom_id',
      asset_title_field: 'asset_title',
      asset_label_field: 'asset_labels',
      earnings_field: 'Not Assigned',
      platform: 'None',
      alias: 'No Aliases',
      report_fields: ['GRid', 'Administer Publish Rights', 'Total Views', 'Gross Youtube-sold Revenue',],
    }
  ];

  const [activeCurrentIndex, setActiveCurrentIndex] = useState(false);

  const toggleShowAccordion = (id) => {
    if (activeCurrentIndex === id) {
      setActiveCurrentIndex();
    } else {
      setActiveCurrentIndex(id);
    }
  }

  return (<>
    <div className="flex-1 my-8 w-full mx-auto">
      <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div className="md:flex md:items-center md:justify-between my-5">
          <div className="flex-1 min-w-0 grid grid-cols-2">
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Report Types</h2>
            <div className="flex justify-end mt-2">
              <Link to="/reports/add" type="button" className="button bg-blue-700 py-2 px-2 border rounded-md shadow-sm text-xs font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Add Report Type</Link>
            </div>
          </div>
        </div>
        {reportTypeData.map((item) => (<>
          <div class="accordion" key={item.id}>
            <div class="accordion-item bg-white border border-gray-100 grid grid-cols-2">
              <h3 class="accordion-header mb-0" id="headingOne">
                <button class="accordion-button relative flex items-center w-full py-4 px-5 text-lg font-medium text-gray-900 text-left bg-white border-0 rounded-none transition focus:outline-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                  aria-controls="collapseOne"
                  onClick={() => toggleShowAccordion(item.id)}>
                  {item.report_type}
                </button>
              </h3>
              <div className="flex justify-end mx-10">
                <button onClick={() => toggleShowAccordion(item.id)}>
                  {activeCurrentIndex === item.id ?
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                    </svg> :
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>}
                </button>
              </div>
            </div>
            {activeCurrentIndex === item.id &&
              <div className="border-t border border-gray-100 px-4 py-5">
                <dl className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Asset ID Field</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.asset_id_field}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Custom ID Field</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.custom_id_field}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Asset Title Field</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.asset_title_field}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Asset Label Field</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.asset_label_field}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Earnings Field</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.earnings_field}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Platform</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.platform}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Alias</dt>
                    <dd className="mt-1 text-sm text-gray-900">{item.alias}</dd>
                  </div>
                  <div className="sm:col-span-2">
                    <dt className="text-sm font-medium text-gray-500">Report Fields</dt>
                    <dd className="mt-1 text-sm text-gray-900"> {item.report_fields.join(', ')}
                    </dd>
                  </div>
                </dl>
                <div className="flex justify-end">
                  <Link to="/reports/edit" type="button" className="button bg-blue-600 py-2 px-2 h-8 border rounded-md shadow-sm text-xs font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Edit</Link>
                  <Link to="#" type="button" className="button bg-red-500 py-2 px-2 h-8 border rounded-md shadow-sm text-xs font-medium text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">Delete</Link>
                </div>
              </div>}
          </div>
        </>))}
      </div>
    </div>

  </>);
}

export default ReportTypeTable;